import { ValueOf } from '../utilities/types';

const caseStatuses = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  IN_PROGRESS: 'in-progress',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
} as const;

export type CaseStatuses = ValueOf<typeof caseStatuses>;

export const caseStatusLabels: Record<CaseStatuses, string> = {
  [caseStatuses.OPEN]: 'Open',
  [caseStatuses.IN_PROGRESS]: 'In progress',
  [caseStatuses.PENDING]: 'Pending',
  [caseStatuses.CLOSED]: 'Closed',
  [caseStatuses.SCHEDULED]: 'Scheduled',
};

export default caseStatuses;
